import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectIsTrial = createBasicSelector(
  selectBase,
  base => base.state === 'trial'
)
